import { Icon } from 'components/ui/general';

import { reactSelectComponents } from '../reactSelectComponents';

import styles from '../Select.module.scss';

export const Option = (props: any) => {
  const { isSelected, label, isMulti } = props;
  const { selectProps }: { [key: string]: any } = props;

  return (
    <reactSelectComponents.Option {...props}>
      {isMulti && !!selectProps.multiLabelWithNumber && (
        <>
          <input
            type="checkbox"
            checked={isSelected}
            onChange={() => null}
            className={styles.optionInput}
          />
          <div className={styles.optionCheckboxHolder}>
            <Icon name="square" font="nuuk" className={styles.optionSquare} />
            <Icon
              name="check-square"
              font="honolulu"
              className={styles.optionCheckSquare}
            />
          </div>
        </>
      )}
      <div>{label}</div>
    </reactSelectComponents.Option>
  );
};
